
import ExternalDrive from "../../../assets/outline/ExternalDrive.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ExternalDriveIcon({ className, dataTestid = "ExternalDriveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ExternalDrive data-testid={dataTestid} className={classes} {...rest} />
  );
}
